import { Flex } from "@chakra-ui/react";
import CalendarCustom from "../CalendarCustom";
import { useIsMobileDevice } from "../../hooks/mobile/useIsMobileDevice";
import { MOBILE_VIEW_TYPE } from "../../types/main";
import { usePreference } from "../../hooks/preference/usePreference";

/**
 * @param {object} props
 * @param {boolean} props.hasBlocksSynchronizedWithGoogle - 백엔드가 보내는 block들과 Google Calendar 동기화 여부
 */
export const RightMainContents = ({
  hasBlocksSynchronizedWithGoogle,
}: {
  hasBlocksSynchronizedWithGoogle: boolean;
}) => {
  const { preference: userPreference } = usePreference();
  const mobileView = userPreference?.mobileView ?? MOBILE_VIEW_TYPE.INBOX;
  const isMobileDevice = useIsMobileDevice();
  const shouldDisplay = isMobileDevice ? mobileView === MOBILE_VIEW_TYPE.CALENDAR : true;

  const RIGHT_MAIN_CONTENTS_MIN_WIDTH = "600px";

  return (
    <Flex
      flex={1}
      minW={isMobileDevice ? "" : RIGHT_MAIN_CONTENTS_MIN_WIDTH}
      position="relative"
      borderRadius="8px"
      border="1px solid rgba(255, 255, 255, 0.04)"
      background="#1b1c1d"
      overflow="hidden"
      display={shouldDisplay ? "block" : "none"}
    >
      <CalendarCustom hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle} />
    </Flex>
  );
};
